import React, { useEffect, useState } from "react";

export function Certifications() {
    const [certifications, setCertifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Dynamically load styles.css from /public/
    useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "/styles.css"; // Path from public folder
        document.head.appendChild(link);
    }, []);

    useEffect(() => {
        fetch("/credlyBadges.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                setCertifications(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error loading badges:", error);
                setError("⚠️ Failed to load certifications.");
                setLoading(false);
            });
    }, []);

    return (
        <main className="certifications-container">
            <h1 className="certifications-title">🏆 My Certifications</h1>

            {loading ? (
                <div className="loading-spinner">🔄 Loading...</div>
            ) : error ? (
                <p className="error-message">{error}</p>
            ) : (
                <div className="certifications-list">
                    {certifications.length > 0 ? (
                        certifications.map((badge, index) => (
                            <div key={index} className="certification-card">
                                <img src={badge.image} alt={badge.name} className="certification-img" />
                                <p className="certification-name">{badge.name}</p>
                            </div>
                        ))
                    ) : (
                        <p className="no-certifications">No certifications found.</p>
                    )}
                </div>
            )}
        </main>
    );
}
